import {version}  from '../../../package.json';

(function () {
    'use strict';

    angular.module('indexModule', ['ngAnimate', 'journey.canvas.srv'])
        .controller('indexCtrl', ['$scope', '$rootScope', '$location', '$timeout', '$stateParams', 'canvasService', 'helpers', 'Session', indexController]);

    function indexController($scope, $rootScope, $location, $timeout, $stateParams, canvasService, helpers, Session) {
        //loader initial state
        $scope.showLoader = false;
        $scope.overflowHidden = false;
        $scope.errorMsgStatus = false;
        $scope.journeyVeil = false;
        $scope.showVeil = false;
        $scope.deactivateModal = false;
        $scope.lang = Session.getCookie('L');
        $scope.removeHide = true;

        $scope.pageTitle = function () {
            var title,
                langs = {
                    spanish: 'Automatizaciónes Pro',
                    french: 'Automatisation Pro',
                    german: 'Profi-Automatisierung',
                    brazil: 'Automations Pro',
                    italian: 'Automazioni Pro',
                    japanese: 'EMA',
                    chineset: '营销规划流程图',
                    chinese: '行銷規劃流程圖',
                    defaultTitle: 'Automation Pro'
                };

            title = langs[$scope.lang] || langs.defaultTitle;

            return title;
        };

        //Checks if path contains canvas word in the url
        let isCanvasPath = () => {
            return $location.path().indexOf('canvas') > -1;
        };

        $scope.reloadJourney = function () {
            location.reload(true);
        };

        //Checking url to display Journey name Element.
        $rootScope.$on('$locationChangeStart', function () {
            $scope.overflowHidden = isCanvasPath();
            $scope.section = isCanvasPath() ? 'canvas-section' : 'home-section';
            $scope.isCanvas = isCanvasPath();
            $scope.isHome = !isCanvasPath();

            $rootScope.isHome_Global = $scope.isHome;
        });

        $rootScope.$on('setBodyOverflow', () => { $scope.overflowHidden = true; });

        $rootScope.$on('removeBodyOverflow', () => {
            if (!isCanvasPath()){
                $scope.overflowHidden = false;
            }
        });

        //Veil Functions
        $scope.$on('displayVeil', function (evt, veilVal) {
            $scope.showVeil = veilVal;
        });

        //Extra Veil Functions for hiding header and Footer
        $rootScope.$on('displayExtraVeil', function (evt, extraVeilVal, extraVeilFooter) {
            $scope.extraVeil = extraVeilVal;
            $scope.extraVeilFooter = typeof extraVeilFooter === 'boolean' ? extraVeilFooter : extraVeilFooter || true;
        });

        //Display Loader
        $rootScope.$on('jbLoader', function (evt, state, transparent) {
            if(transparent) {
                $scope.showLoaderTransparent = state;
            } else {
                if ($scope.showLoader !== state) {
                    $scope.showLoader = state;
                }
            }
        });

        //Display Error Message
        $rootScope.$on('errorMsg', function (evt, msg, type, time = 5000) {
            if ($scope.messageRunning) {
                return;
            }
            $scope.messageRunning = true;
            $scope.errorMsg = msg;
            $scope.errorMsgStatus = true;

            switch (type) {
                case 'confirmation':
                    $scope.confirmation = true;
                    break;
                case 'error':
                    $scope.errorAlert = true;
                    break;
                case 'disconnected':
                    $scope.disconnectAlert = true;
                    break;
                default:
                    $scope.confirmation = false;
                    $scope.errorAlert = false;
                    $scope.disconnectAlert = false;
            }

            $timeout(function () {
                $scope.errorMsgStatus = false;
                $timeout(function () {
                    $scope.confirmation = false;
                    $scope.errorAlert = false;
                    $scope.messageRunning = false;
                    $scope.disconnectAlert = false;
                }, 500);
            }, time);
        });

        //On journey Activation
        $rootScope.$on('journeyActivated', function (evt) {
            $scope.journeyVeil = true;
        });

        //On journey Deactivation
        $scope.$on('activateError', function () {
            $scope.activateError = true;
        });

        $scope.getLocaleFeedback = () => {
            let currentLang = Session.getCookie('L'),
                langs = {
                    spanish: 'es/',
                    french: 'fr/',
                    german: 'de/',
                    brazil: '',
                    italian: 'it/',
                    japanese: 'jp/',
                    chineset: 'cn/',
                    chinese: 'tw/',
                    defaultTitle: ''
                };

           return langs[currentLang] || langs.defaultTitle;
        };

        $scope.displayFeedbackForm = (type) => {
            let settings = JSON.parse(sessionStorage.getItem('settingSession') || ''),
                locale = $scope.getLocaleFeedback();

            $scope.feedBackType = type;
            $scope.feedbackModal = true;
            $scope.feedBackOptions = {};
            Session.getClientDetailsViaAPI().then(function(data) {
                var client_first_name = data["f"];
                var client_last_name = data["l"];
                $scope.feedBackOptions.name = client_first_name + ' ' + client_last_name;
                $scope.feedBackOptions.email = settings.SignEmail;

                $scope.feebackHelpUrl = 'https://www.benchmarkemail.com/' + locale + 'help-email?name=' + encodeURI($scope.feedBackOptions.name) + '&email=' + encodeURI($scope.feedBackOptions.email);

                canvasService.getClientInfo()
                    .then(({data}) => {
                        $scope.feedBackOptions.region = data.Response.RegionName;
                    });

                canvasService.getResponsiveInfo()
                    .then(({data}) => {
                        if(data.Response.ResponsiveOnly == "0") {
                            $scope.feedBackOptions.userType = 'existing';
                        } else {
                            $scope.feedBackOptions.userType = 'new';
                        }
                    });

                canvasService.getPlanInfo()
                    .then(({data}) => {
                        $scope.feedBackOptions.plan = data.Response.EmailPlan.PlanName;
                    });
            });
        };

        $scope.hideFeedbackModal = () => {
            $scope.feedbackModal = false;
            $scope.feedbackMsg = '';
        };

        $scope.sendFeedback = () => {
            if(!$scope.feedbackMsg) {
                $scope.feedbackError = true;
                $timeout(() => {
                    $scope.feedbackError = false;
                }, 3000);
            } else {
                // send the feedback to google spreadsheet
                let payload = {
                    email: $scope.feedBackOptions.email,
                    name: $scope.feedBackOptions.name,
                    user_type: $scope.feedBackOptions.userType,
                    is_paid: Session.getCookie('isPaid') == '1',
                    plan_name: $scope.feedBackOptions.plan,
                    region: $scope.feedBackOptions.region,
                    language: $scope.lang || 'english',
                    type: $scope.feedBackType,
                    date_submitted: new Date(),
                    message: $scope.feedbackMsg,
                    'Full Story Review': '',
                    'Action to Take': '',
                    'Zendesk Tickets Created': ''
                };


                if(!$scope.isLoading && window.IS_PROD) {
                    $scope.isLoading = true;
                    canvasService.sendFeedback(payload)
                        .then(() => {
                            $scope.hideFeedbackModal();
                            $scope.isLoading = false;
                        })
                        .catch(() => {
                            $scope.hideFeedbackModal();
                            $scope.isLoading = false;
                        });
                }

                $scope.feedbackError = false;
            }
        };

        $rootScope.$on('closeMenus', function(evt, close) {
            if(close){
                $scope.closeMenus();
            }
        });

        $scope.closePreviewModal = () => {
            $scope.emailPreviewIn = false;

            if($rootScope.currentJourneyStatus === 3 ||
                $rootScope.currentJourneyStatus === 4 ||
                $rootScope.currentJourneyStatus === 8) {
                // For close the preview email on active send email
                $rootScope.$emit('closePreviewEmail' + $scope.previewId);
                $scope.emailPreview = false;
            } else {
                $timeout(()=>{
                    $scope.emailPreview = false;
                    if($scope.emailPreviewData.conn == 'showEmailList') {
                        $rootScope.$emit('closePreviewEmailShowModal' + $scope.previewId);
                    } else {
                        $rootScope.$emit('displayActionSendEmailModal', $scope.emailPreviewData.conn, false, true);
                    }
                }, 300);
            }
        };

        $scope.emailPreviewData = {};
        $scope.emailPreviewIn = false;
        $rootScope.$on('previewEmail', function(evt, conn, isSelected, showTooltip, id) {
            $scope.emailPreviewData = {
                conn: conn,
                isSelected: isSelected,
                showTooltip: showTooltip
            };

            if(id) {
                $scope.previewId = id;
            }

            $scope.emailPreview = true;
            $timeout(()=> {
                $scope.emailPreviewIn = true;
            }, 300)

        });

        $scope.closeMenus = function () {
            $scope.$broadcast('hideSubMenuIf');
            $scope.$broadcast('hideHomeMenus');
            $scope.$broadcast('hideFooterMenu');
            $scope.$broadcast('hideHeaderMenu');
            if (isCanvasPath()) {
                $scope.$broadcast('hideHeaderHomeMenu');
                $scope.$broadcast('hideFooterSaveTemplate');
                $scope.$broadcast('hideUseTemplateModal');
                $scope.$broadcast('closeConfigMenus');
                $scope.$broadcast('closeCoaching');
                $scope.$broadcast('closeTemplateMenu');
                $rootScope.$emit('closeInnerMenuIfElse');
            }
        };
    };

})();



// WEBPACK FOOTER //
// ./app/controllers/indexController.js